/**
 * Metadatos de catálogos de Adquisiciones (Ajustes).
 * Los ítems viven en PostgreSQL vía /api/procurement/catalogs.
 */

export const CATALOG_DEFINITIONS = [
  {
    key: 'payment_conditions',
    group: 'master',
    label: 'Condiciones de pago',
    description: 'Opciones del selector múltiple en proveedores.',
  },
  {
    key: 'supplier_types',
    group: 'master',
    label: 'Tipos de proveedor',
    description: 'Clasificación del proveedor (materias primas, insumos, etc.).',
  },
  {
    key: 'currencies',
    group: 'orders',
    label: 'Monedas',
    description: 'Opciones de moneda disponibles en el formulario de órdenes de compra.',
  },
  {
    key: 'document_types',
    group: 'orders',
    label: 'Tipos de documento',
    description: 'Tipo de documento en órdenes de compra (factura afecta, exenta, etc.).',
  },
  {
    key: 'item_types',
    group: 'orders',
    label: 'Tipos de ítem',
    description: 'Clasificación de líneas en OC (materias primas, insumos, servicios, etc.).',
  },
  {
    key: 'delivery_conditions',
    group: 'orders',
    label: 'Condiciones de entrega',
    description: 'Opciones de condición de entrega en órdenes de compra.',
  },
  {
    key: 'order_statuses',
    group: 'orders',
    label: 'Estados de OC',
    description:
      'Estados del flujo de órdenes de compra. Este catálogo es de referencia y no admite modificaciones.',
    readOnly: true,
  },
];

export const CATALOG_GROUPS = [
  {
    key: 'master',
    label: 'Maestros',
    description: 'Catálogos usados en el formulario y la ficha de proveedores.',
  },
  {
    key: 'orders',
    label: 'Órdenes de compra',
    description: 'Catálogos del formulario de órdenes de compra.',
  },
];

export const codeFromLabel = (label) =>
  String(label || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 40);

export const toUiCatalogRow = (row) => ({
  ...row,
  is_active:
    row?.is_active_label ||
    (row?.is_active === true || row?.is_active === 'Sí' || row?.is_active === 'si' ? 'Sí' : 'No'),
});

export const getActiveOptionsFromRows = (rows = [], { valueFromCode = false } = {}) =>
  [...rows]
    .filter((row) => {
      const active = row?.is_active;
      if (typeof active === 'boolean') return active;
      return String(active || '').toLowerCase() === 'sí' || String(active || '').toLowerCase() === 'si';
    })
    .sort(
      (a, b) =>
        Number(a.sort_order || 0) - Number(b.sort_order || 0) ||
        String(a.label || '').localeCompare(String(b.label || ''), 'es')
    )
    .map((row) => {
      const code = String(row.code || '').trim();
      const label = String(row.label || code).trim();
      const value = valueFromCode ? code || label : label;
      return {
        value,
        label: valueFromCode && code && label && code !== label ? `${code} · ${label}` : label || code,
        code,
      };
    });
